export function updateCurrency(currency) {
  return (dispatch) => {
    dispatch({ type: 'CURRENCY_UPDATED', currency })
  }
}
